import { render, staticRenderFns } from "./CardDeck.vue?vue&type=template&id=9af6b4e6&"
import script from "./CardDeck.vue?vue&type=script&lang=js&"
export * from "./CardDeck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports